import { ProgressStarFourPointsIcon } from './ProgressStarFourPointsIcon';

/**
 * author: Jeff Anders
 * id C8BCB1CF-5259-4BC0-B368-4F5C2A3C194B
 * name progress-star-four-points
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/progress-star-four-points.svg
 * tags
 */
export const ProgressAutoIcon = ProgressStarFourPointsIcon;
export default ProgressAutoIcon